module.exports = __webpack_public_path__ + "img/snb_gdco.be786f3c.svg";